<template>
  <div>

    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div>
        <h2 class="text-2xl font-bold text-slate-800">Promociones</h2>
        <p class="text-slate-500 text-sm mt-1">Gestiona las promociones y descuentos disponibles en los planes.</p>
      </div>
      <button
        @click="abrirNuevo"
        class="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-xl font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 self-start sm:self-auto"
      >
        <i class="fa-solid fa-plus"></i>
        Nueva Promocion
      </button>
    </div>

    <!-- Tabla -->
    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">#</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Nombre</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Descuento</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Aplica a</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Vigencia</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Estatus</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100">

            <tr v-if="cargando">
              <td colspan="7" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-spinner fa-spin text-2xl text-emerald-400 mr-2"></i>
                Cargando...
              </td>
            </tr>

            <tr v-else-if="promociones.length === 0">
              <td colspan="7" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-tag text-3xl mb-2 block"></i>
                No hay promociones registradas
              </td>
            </tr>

            <tr
              v-else
              v-for="(item, idx) in promociones"
              :key="item.idPromocion"
              class="hover:bg-slate-50 transition-colors duration-150"
            >
              <td class="px-6 py-4 text-slate-400 text-xs">{{ idx + 1 }}</td>

              <td class="px-6 py-4">
                <div class="flex items-center gap-2">
                  <div class="w-8 h-8 rounded-full bg-gradient-to-br from-orange-400 to-pink-500 flex items-center justify-center flex-shrink-0">
                    <i class="fa-solid fa-tag text-white text-xs"></i>
                  </div>
                  <div>
                    <p class="font-semibold text-slate-800">{{ item.nomPromocion }}</p>
                    <p class="text-slate-400 text-xs truncate max-w-xs">{{ item.desPromocion }}</p>
                  </div>
                </div>
              </td>

              <td class="px-6 py-4">
                <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold bg-orange-100 text-orange-700">
                  <i class="fa-solid fa-percent text-xs"></i>
                  {{ item.porcentaje }}% OFF
                </span>
              </td>

              <td class="px-6 py-4">
                <span v-if="item.todasLosPlanes" class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
                  <i class="fa-solid fa-layer-group text-xs"></i>
                  Todos los planes
                </span>
                <span v-else class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-violet-100 text-violet-700">
                  <i class="fa-solid fa-list-check text-xs"></i>
                  {{ item.idPlanes.length }} plan{{ item.idPlanes.length !== 1 ? 'es' : '' }} especifico{{ item.idPlanes.length !== 1 ? 's' : '' }}
                </span>
              </td>

              <td class="px-6 py-4 text-slate-500 text-xs whitespace-nowrap">
                {{ formatFecha(item.fechaInicio) }} &rarr; {{ formatFecha(item.fechaFinal) }}
              </td>

              <td class="px-6 py-4">
                <span :class="['inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold',
                               item.estatus === 'A' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600']">
                  <span :class="['w-1.5 h-1.5 rounded-full', item.estatus === 'A' ? 'bg-emerald-500' : 'bg-red-500']"></span>
                  {{ item.estatus === 'A' ? 'Activa' : 'Inactiva' }}
                </span>
              </td>

              <td class="px-6 py-4">
                <div class="flex items-center gap-2">
                  <button
                    @click="editar(item)"
                    class="p-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 transition-colors duration-150"
                    title="Editar"
                  >
                    <i class="fa-solid fa-pen-to-square text-xs"></i>
                  </button>
                  <button
                    @click="cambiarEstatus(item)"
                    :class="['p-2 rounded-lg transition-colors duration-150',
                             item.estatus === 'A'
                               ? 'bg-red-50 hover:bg-red-100 text-red-500'
                               : 'bg-emerald-50 hover:bg-emerald-100 text-emerald-600']"
                    :title="item.estatus === 'A' ? 'Desactivar' : 'Activar'"
                  >
                    <i :class="['text-xs', item.estatus === 'A' ? 'fa-solid fa-ban' : 'fa-solid fa-check']"></i>
                  </button>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <transition name="modal">
      <div v-if="modalVisible" class="fixed inset-0 z-50 flex items-center justify-center modal-overlay p-4">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-xl animate-fade-in">

          <!-- Header modal -->
          <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100">
            <h3 class="font-bold text-slate-800 text-lg">
              <i class="fa-solid fa-tag text-emerald-500 mr-2"></i>
              {{ modoEdicion ? 'Editar Promocion' : 'Nueva Promocion' }}
            </h3>
            <button @click="cerrarModal" class="text-slate-400 hover:text-slate-600 p-1">
              <i class="fa-solid fa-xmark text-lg"></i>
            </button>
          </div>

          <!-- Cuerpo modal -->
          <div class="px-6 py-5 space-y-4 max-h-[70vh] overflow-y-auto">

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                Nombre de la promocion <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.nomPromocion"
                type="text"
                maxlength="150"
                placeholder="Ej. Descuento de verano"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                Descripcion <span class="text-red-500">*</span>
              </label>
              <textarea
                v-model="form.desPromocion"
                maxlength="500"
                rows="2"
                placeholder="Ej. Aplica en todos los planes durante el mes de julio"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all resize-none"
              ></textarea>
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                Porcentaje de descuento (%) <span class="text-red-500">*</span>
              </label>
              <input
                v-model.number="form.porcentaje"
                type="number"
                min="1"
                max="100"
                step="0.01"
                placeholder="Ej. 20"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />
            </div>

            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1">
                  Fecha inicio <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.fechaInicio"
                  type="date"
                  class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
                />
              </div>
              <div>
                <label class="block text-sm font-semibold text-slate-700 mb-1">
                  Fecha final <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.fechaFinal"
                  type="date"
                  class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
                />
              </div>
            </div>

            <!-- Aplica a -->
            <div class="border border-slate-200 rounded-xl p-4 bg-slate-50">
              <label class="block text-sm font-semibold text-slate-700 mb-3">
                <i class="fa-solid fa-layer-group text-slate-400 mr-1"></i>
                Aplica a
              </label>

              <div class="flex gap-3 mb-3">
                <button
                  type="button"
                  @click="form.todasLosPlanes = true"
                  :class="['flex-1 py-2 rounded-xl text-xs font-semibold border transition-all',
                           form.todasLosPlanes
                             ? 'bg-emerald-600 text-white border-emerald-600 shadow'
                             : 'bg-white text-slate-600 border-slate-300 hover:border-emerald-400']"
                >
                  <i class="fa-solid fa-layer-group mr-1"></i>
                  Todos los planes
                </button>
                <button
                  type="button"
                  @click="form.todasLosPlanes = false"
                  :class="['flex-1 py-2 rounded-xl text-xs font-semibold border transition-all',
                           !form.todasLosPlanes
                             ? 'bg-violet-600 text-white border-violet-600 shadow'
                             : 'bg-white text-slate-600 border-slate-300 hover:border-violet-400']"
                >
                  <i class="fa-solid fa-list-check mr-1"></i>
                  Planes especificos
                </button>
              </div>

              <div v-if="!form.todasLosPlanes">
                <div v-if="cargandoPlanes" class="text-center py-4 text-slate-400 text-xs">
                  <i class="fa-solid fa-spinner fa-spin mr-1"></i> Cargando planes...
                </div>
                <div v-else-if="planes.length === 0" class="text-center py-4 text-slate-400 text-xs">
                  No hay planes disponibles
                </div>
                <div v-else class="space-y-1 max-h-44 overflow-y-auto pr-1">
                  <label
                    v-for="plan in planes"
                    :key="plan.idPlan"
                    class="flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer hover:bg-white transition-colors"
                    :class="form.idPlanes.includes(plan.idPlan) ? 'bg-white ring-1 ring-violet-300' : ''"
                  >
                    <input
                      type="checkbox"
                      :value="plan.idPlan"
                      v-model="form.idPlanes"
                      class="w-4 h-4 rounded accent-violet-600"
                    />
                    <div class="flex-1 min-w-0">
                      <p class="text-sm font-semibold text-slate-800 truncate">{{ plan.nombrePlan }}</p>
                      <p class="text-xs text-slate-400 truncate">{{ plan.nombreSistema }}</p>
                    </div>
                    <span class="text-xs font-bold text-slate-500">${{ formatPrecio(plan.precio) }}</span>
                  </label>
                </div>
                <p v-if="!form.todasLosPlanes && form.idPlanes.length === 0" class="text-xs text-red-500 mt-2">
                  <i class="fa-solid fa-triangle-exclamation mr-1"></i>
                  Selecciona al menos un plan
                </p>
              </div>

            </div>

          </div>

          <!-- Footer modal -->
          <div class="flex justify-end gap-3 px-6 py-4 border-t border-slate-100">
            <button
              @click="cerrarModal"
              class="px-5 py-2.5 rounded-xl border border-slate-300 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-all"
            >Cancelar</button>
            <button
              @click="guardar"
              :disabled="guardando"
              class="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <i v-if="guardando" class="fa-solid fa-spinner fa-spin mr-1"></i>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>

        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import servicio      from '@/services/promociones.service'
import servicioPlan  from '@/services/planes.service'

export default {
  name: 'PromocionesAdmin',
  data () {
    return {
      promociones:    [],
      planes:         [],
      cargando:       false,
      cargandoPlanes: false,
      guardando:      false,
      modalVisible:   false,
      modoEdicion:    false,
      form: {
        idPromocion:    0,
        nomPromocion:   '',
        desPromocion:   '',
        porcentaje:     null,
        fechaInicio:    '',
        fechaFinal:     '',
        estatus:        'A',
        todasLosPlanes: true,
        idPlanes:       []
      }
    }
  },
  mounted () {
    this.cargar()
    this.cargarPlanes()
  },
  methods: {
    formatFecha (fecha) {
      if (!fecha) return ''
      return new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
    },

    formatPrecio (valor) {
      return Number(valor).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    },

    async cargar () {
      this.cargando = true
      try {
        const res = await servicio.promocionesCon(false)
        if (!res.data.resultado) {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje || 'Error al cargar promociones', tipo: 'error' })
          this.promociones = []
          return
        }
        this.promociones = res.data.promociones || []
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cargar promociones', tipo: 'error' })
      } finally {
        this.cargando = false
      }
    },

    async cargarPlanes () {
      this.cargandoPlanes = true
      try {
        const res = await servicioPlan.planesCon(0)
        this.planes = (res.data.planes || []).filter(p => p.estatus === 'A')
      } catch {
        this.planes = []
      } finally {
        this.cargandoPlanes = false
      }
    },

    abrirNuevo () {
      this.modoEdicion          = false
      this.form.idPromocion     = 0
      this.form.nomPromocion    = ''
      this.form.desPromocion    = ''
      this.form.porcentaje      = null
      this.form.fechaInicio     = ''
      this.form.fechaFinal      = ''
      this.form.estatus         = 'A'
      this.form.todasLosPlanes  = true
      this.form.idPlanes        = []
      this.modalVisible         = true
    },

    editar (item) {
      this.modoEdicion          = true
      this.form.idPromocion     = item.idPromocion
      this.form.nomPromocion    = item.nomPromocion
      this.form.desPromocion    = item.desPromocion
      this.form.porcentaje      = item.porcentaje
      this.form.fechaInicio     = item.fechaInicio ? item.fechaInicio.substring(0, 10) : ''
      this.form.fechaFinal      = item.fechaFinal  ? item.fechaFinal.substring(0, 10)  : ''
      this.form.estatus         = item.estatus
      this.form.todasLosPlanes  = item.todasLosPlanes
      this.form.idPlanes        = item.idPlanes ? [...item.idPlanes] : []
      this.modalVisible         = true
    },

    cerrarModal () {
      this.modalVisible = false
    },

    async guardar () {
      if (!this.form.nomPromocion.trim()) {
        this.$store.dispatch('mostrarToast', { mensaje: 'El nombre de la promocion es obligatorio', tipo: 'warning' })
        return
      }
      if (!this.form.desPromocion.trim()) {
        this.$store.dispatch('mostrarToast', { mensaje: 'La descripcion es obligatoria', tipo: 'warning' })
        return
      }
      if (!this.form.porcentaje || this.form.porcentaje <= 0 || this.form.porcentaje > 100) {
        this.$store.dispatch('mostrarToast', { mensaje: 'El porcentaje debe estar entre 1 y 100', tipo: 'warning' })
        return
      }
      if (!this.form.fechaInicio) {
        this.$store.dispatch('mostrarToast', { mensaje: 'La fecha de inicio es obligatoria', tipo: 'warning' })
        return
      }
      if (!this.form.fechaFinal) {
        this.$store.dispatch('mostrarToast', { mensaje: 'La fecha final es obligatoria', tipo: 'warning' })
        return
      }
      if (this.form.fechaFinal < this.form.fechaInicio) {
        this.$store.dispatch('mostrarToast', { mensaje: 'La fecha final debe ser mayor o igual a la fecha de inicio', tipo: 'warning' })
        return
      }
      if (!this.form.todasLosPlanes && this.form.idPlanes.length === 0) {
        this.$store.dispatch('mostrarToast', { mensaje: 'Selecciona al menos un plan especifico', tipo: 'warning' })
        return
      }

      this.guardando = true
      try {
        const res = await servicio.guardar(this.form)
        if (res.data.resultado) {
          this.cerrarModal()
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })
          await this.cargar()
        } else {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })
        }
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al guardar la promocion', tipo: 'error' })
      } finally {
        this.guardando = false
      }
    },

    async cambiarEstatus (item) {
      const nuevoEstatus = item.estatus === 'A' ? 'I' : 'A'
      try {
        const res = await servicio.cambiarEstatus({ idPromocion: item.idPromocion, estatus: nuevoEstatus })
        if (res.data.resultado) {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })
          await this.cargar()
        } else {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })
        }
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cambiar estatus', tipo: 'error' })
      }
    }
  }
}
</script>
